import React, { useEffect } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";
import Storage from "../Images/12.jpg";

const StorageSolutions = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "1100px",
        margin: "auto",
        marginTop: "60px",
      }}
    >
      {/* Main Title */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: { xs: "1.75rem", lg: "2rem" },
          fontWeight: "bold",
          textAlign: { xs: "left", md: "center" },
          mb: 4,
        }}
      >
        Logistics & Storage Solutions
      </Typography>

      {/* Introduction Paragraph */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.2rem",
          "@media (min-width: 1024px)": { fontSize: "1.4rem" },
          mb: 4,
        }}
      >
        Our comprehensive logistics and storage services are designed to
        streamline your wholesale and export operations.
      </Typography>

      {/* Two-column layout for content and storage image */}
      <Grid container spacing={4}>
        {/* Left column - Services list */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              color: "#1e3a8a",
              fontSize: "1.5rem",
              fontWeight: "bold",
              "@media (min-width: 1024px)": { fontSize: "1.75rem" },
              mb: 3,
            }}
          >
            We offer:
          </Typography>

          <List sx={{ mb: 4 }}>
            {[
              "Secure, modern warehousing for short- or long-term storage",
              "Standard storage options for all types of products",
              "Inventory management, order consolidation, and re-packing services",
              "Pallet and loose box storage to match your order volume",
              "Flexible collection and dispatch schedules to meet your supply chain needs",
            ].map((item, index) => (
              <ListItem key={index} sx={{ padding: "4px 0" }}>
                <ListItemText
                  primary={
                    <Typography
                      component="span"
                      sx={{
                        color: "#1D1616",
                        fontSize: "1.2rem",
                        "@media (min-width: 1024px)": { fontSize: "1.3rem" },
                        display: "flex",
                        alignItems: "flex-start",
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>•</span> {item}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>

          <Typography
            variant="body1"
            paragraph
            sx={{
              color: "#1D1616",
              fontSize: "1.2rem",
              "@media (min-width: 1024px)": { fontSize: "1.4rem" },
              mb: 4,
            }}
          >
            Let us take care of the logistics, so you can focus on growing your
            business.
          </Typography>
        </Grid>

        {/* Right column - Storage image */}
        <Grid item xs={12} md={6}>
          <Box>
            <Box
              sx={{
                padding: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                height: "100%",
              }}
            >
              <img
                src={Storage}
                alt="Storage Solutions"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <ContactChat />
    </Box>
  );
};

export default StorageSolutions;
